import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { LandingScreen } from './screens';
import GetStartedScreen from './screens/GetStartedScreen';
import { initFirebase } from './analytics';
import { ToastProvider } from './contexts/ToastContext';

const App: React.FC = () => {
    useEffect(() => {
        // Initialize analytics when app loads
        initFirebase();
    }, []);

    return (
        <ToastProvider>
            <Router>
                <div className="App">
                    <Routes>
                        
                         <Route path="/" element={<GetStartedScreen initialStep={2} />} />
                        {/*<Route path="/signup" element={<GetStartedScreen initialStep={1} />} /> */}
                        <Route path="/linkBankAccount" element={<GetStartedScreen initialStep={2} />} />
                        <Route path="/verification" element={<GetStartedScreen initialStep={3} />} />
                        {/* Future routes will be added here */}
                    </Routes>
                </div>
            </Router>
        </ToastProvider>
    );
};

export default App; 